export default "__VITE_ASSET__COHVChrT__"